import * as React from 'react';
import { Box, Flex } from '@awning/components';
import { MaskedData } from '@/src/MaskedData/MaskedData';

export const TopMarketMarkerRef = React.createRef<HTMLElement>();

export const TopMarketMarker = () => {
  const fontFamily = `"Benton Sans", "Helvetica Neue", "Arial", sans-serif`;
  return (
    <Box
      ref={TopMarketMarkerRef}
      sx={{
        fontFamily,
        borderStyle: 'none',
        borderWidth: 0,
        position: 'absolute',
        cursor: 'pointer',
        visibility: 'hidden',
        transition: 'transform 100ms',
      }}
    >
      <Flex
        as="a"
        target="_blank"
        rel="noreferrer"
        sx={{
          textDecoration: 'none',
          fontFamily,
          borderStyle: 'none',
          borderWidth: 0,
          position: 'absolute',
          cursor: 'pointer',
          height: '32px',
          minWidth: '40px',
          maxWidth: '80px',
          borderRadius: '16px',
          background: '#fff',
          padding: '2px 8px',
          alignItems: 'center',
          alignContent: 'center',
          justifyContent: 'center',
          gap: 1,
          fontSize: '12px',
          fontWeight: 'bold',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1),0 2px 4px -1px rgba(0, 0, 0, 0.6)',
          display: 'none',
        }}
        className="custom-marker"
      >
        <Flex
          className="position-index-tag"
          sx={{
            display: 'none',
            text: 'xs',
            color: 'white',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#37764C',
            borderRadius: 'full',
            height: '25px',
            width: '25px',
            padding: 2,
          }}
        ></Flex>
        <Box className="content">
          <MaskedData />
        </Box>
      </Flex>
    </Box>
  );
};
